module.exports = {
    "collapse": `Skjul`,
    "expand": `Udvid`
};


//# sourceMappingURL=da-DK.main.js.map
